import { ToolOptionsRendererProps } from '../../../BaseToolbar.types';
import { ToolOptionsProps } from '../ToolOptionsRenderer.types';
import { observer } from 'mobx-react-lite';
import { AdjustmentsDesktopView } from '@photosi/rn-components/tools/adjustments/adjustments-desktop/adjustments-desktop-view/AdjustmentsDesktopView';

export const AdjustmentToolOptions = observer((props: ToolOptionsRendererProps<ToolOptionsProps>) => {
  return <AdjustmentsDesktopView focusable={props.isActive} />;
});

AdjustmentToolOptions.displayName = 'AdjustmentToolOptions';
